import { api } from './api';

export const fetchLogs = (params) => {
  return api.get(`/log/event`, params);
};
